import { useSelector } from "react-redux";
import GenericSpinnerLoader from "../../../loaders/GenericSpinnerLoader";
import CreateAsnModal from "./CreateAsnModal";
import React, {useState, useEffect, use} from "react";  


const CreateAsnModalWrapper = (props) => {

    const [loading, setLoading] = useState(false);

    const digivendStore = useSelector((state) => state.digivendStore);

    const refreshAsnModal = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false)
        }, 100)
    }

    useEffect(() => {
        if(digivendStore?.checkAsnRestrictionData?.isSuccess) {
            if(digivendStore?.checkAsnRestrictionData?.data?.resource?.asnRestrict == 1) {
                setTimeout(() => {
                    setLoading(false)
                }, 200);
            }
            else {
                setTimeout(() => {
                    setLoading(false)
                }, 200);
            }
        }
        if(digivendStore?.checkAsnRestrictionData?.isLoading) {
            setLoading(true);
        }
    }, [digivendStore?.checkAsnRestrictionData?.isSuccess, digivendStore?.checkAsnRestrictionData?.isLoading])


    if(loading || digivendStore?.checkAsnRestrictionData?.isLoading) {
        return <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width:"100%"}}>
            <GenericSpinnerLoader/>
        </div>
    }

    return <CreateAsnModal {...props} refreshAsnModal={refreshAsnModal}/>

}

export default CreateAsnModalWrapper;